import { VendorMetadataBlock } from "./VendorMetadataBlock";

export function VendorMetadataDiscountsBlock() {
  return <VendorMetadataBlock blockSettings={{ metadataType: "DISCOUNT" }} />;
}
